import { render, staticRenderFns } from "./CoursesNumbers.vue?vue&type=template&id=bab8483a&scoped=true&"
import script from "./CoursesNumbers.vue?vue&type=script&lang=ts&"
export * from "./CoursesNumbers.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesNumbers.vue?vue&type=style&index=0&id=bab8483a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab8483a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VProgressLinear,VRow})
